export const tabsTechnologicalFeatures = [
    {
        label: 'generalInformation',
        qtd: 4,
        qtdToFill: 4,
        isValidated: false
    },  
    {
        label: 'companyPerformance',
        qtd: 10,
        qtdToFill: 10,
        isValidated: false
    }, 
    {
        label: 'innovationHistoric',
        qtd: 4,
        qtdToFill: 4,
        isValidated: false
    }, 
    {
        label: 'innovationActivity',
        qtd: 13,
        qtdToFill: 13,
        isValidated: false
    }
];